// extracted by mini-css-extract-plugin
module.exports = {"container":"documents_container__2-naD"};